import './modules/Newsletter/newsletter.module';
// @ts-ignore
window.SMB_WIDGETS_VERSION = '0.1.0-3';
